export var GrantType;
(function (GrantType) {
    GrantType["AUTHORIZATION_CODE"] = "AUTHORIZATION_CODE";
    GrantType["CLIENT_CREDENTIALS"] = "CLIENT_CREDENTIALS";
    GrantType["PKCE"] = "PKCE";
})(GrantType || (GrantType = {}));
